import { EVENT_TOPIC_MATRIX } from "./event-topic-matrix";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, map } from "rxjs";

import { environment } from "src/environments/environment";
import { 
    IActionOdataResult,
    IActionResult,
    IEvent,
    IParamObj,
    IParamQuery,
    EventObj,
    IEventDetailTopic
} from "../models";

/**
 * Service to handle events, including fetching, creating, and updating events.
 * It also manages the current event state using a BehaviorSubject.
 */
@Injectable({
    providedIn: 'root'
})
export class EventService {
    constructor(private http: HttpClient) {}
    public $currentEvent = new BehaviorSubject<EventObj>(new EventObj());

    private _EVENT_DETAIL_TOPICS: IEventDetailTopic[] = EVENT_TOPIC_MATRIX.map(topic => ({ ...topic }));

    public get EVENT_DETAIL_TOPICS(): IEventDetailTopic[] {
        return this._EVENT_DETAIL_TOPICS;
    }
    
    public refreshCurrentEvent(id?: number): Observable<EventObj> {
        if (id) {
            return this.getEventFullDetails(id).pipe(map((result) => {
                this.$currentEvent.next(result.data as EventObj);
                return result.data as EventObj
            }));
        }
        this.$currentEvent.next(new EventObj());
        return this.$currentEvent.asObservable();
    }

    private getEventFullDetails = (id: number): Observable<IActionResult> => this.http.get<IActionResult>(environment.apiBaseURL + 'Event/GetEventFullDetails?key=' + id);

    /**
     * Will create a new event and Return the newly created event
     */
    public post(): Observable<EventObj> {
        return this.postEvent(this.$currentEvent.value).pipe(map((result) => result.data as EventObj))
    }

    private postEvent(event: EventObj): Observable<IActionResult> {
        return this.http.post<IActionResult>(environment.apiBaseURL + 'Event/CreateEvent', event);
    }


    /**
     * Will update an existing event and Return the newly updated event
     */
    public update(): Observable<EventObj> {
        return this.updateEvent(this.$currentEvent.value).pipe(map((result) => result.data as EventObj))
    }

    private updateEvent(event: EventObj): Observable<IActionResult> {
        return this.http.post<IActionResult>(environment.apiBaseURL + 'Event/UpdateEvent', event);
    }

    /**
     * Returns an array of event types based on http query params
     */
    public get(params?: IParamObj): Observable<Array<IEvent>> {
        const paramQuery: IParamQuery = (params) ? { params: params } : null;
        return this.getEvents(paramQuery).pipe(map((result) => result.value as Array<IEvent>));
    }

    private getEvents(paramQuery: IParamQuery): Observable<IActionOdataResult> {
        const httpParams = (paramQuery) ? paramQuery : {};
        return this.http.get<IActionOdataResult>(environment.apiBaseURL + 'odata/Events', httpParams);
    }
}
